<template>
    <div>
        <b-card class="standardpage">
            <b-card-header>
                <b-row>
                    <b-col cols="12" sm="6" class="text-right text-sm-left pt-1">
                        <i :class="solar.icon" class="mr-1"></i>
                        <span>{{ solar.title }}</span>
                    </b-col>
                </b-row>
            </b-card-header>
            <b-card-body class="w-100%">
                <b-aspect :aspect="aspect">
                    <div> <b-embed type="iframe"
                            src="https://monitoringpublic.solaredge.com/solaredge-web/p/kiosk?guid=256cc15c-e61b-4669-9913-94dd0e87d9ee"
                            allowfullscreen></b-embed></div>
                </b-aspect>

            </b-card-body>

        </b-card>
    </div>
</template>
    
    
<script>
import gql from "graphql-tag";

export default {
    name: "Solar",
    components: {},

    data() {
        return {
            aspect: '16:9',
            aspects: [
                { text: '4:3 (SD)', value: '4:3' },
                { text: '1:1 (Square)', value: '1:1' },
                { text: '16:9 (HD)', value: '16:9' },
                { text: '1.85:1 (Widescreen)', value: '1.85:1' },
                { text: '2:1 (Univisium/Superscope)', value: '2:1' },
                { text: '21:9 (Anamorphic)', value: '21:9' },
                { text: '1.43:1 (IMAX)', value: '1.43:1' },
                { text: '3:2 (35mm Film)', value: '3:2' },
                { text: '3:1 (APS-P)', value: '3:1' },
                { text: '4/3 (Same as 4:3)', value: 4 / 3 },
                { text: '16/9 (Same as 16:9)', value: 16 / 9 },
                { text: '3 (Same as 3:1)', value: 3 },
                { text: '2 (Same as 2:1)', value: 2 },
                { text: '1.85 (Same as 1.85:1)', value: 1.85 },
                { text: '1.5', value: 1.5 },
                { text: '1 (Same as 1:1)', value: 1 }
            ],
            solar: {
                title: "TP Solar ( Podium House )",
                icon: "fa fa-certificate",
                debounce: 500,
                busy: false,
            },
        };
    },

};
</script>
    
<style></style>